import axiosInstance from "../axios/axiosInstance";
import { buildApiUrl } from "../../config/api";

const API = buildApiUrl("/interviewQuestionApp/candidate_exam/");

export const candidateExamService = {
  //TODO: Fix payload structure
  async submitExam(
    examId: number,
    payload: { answers: any[]; writing_test: any[] }
  ) {
    return await axiosInstance.post(`${API}submit-exam/${examId}/`, {
      payload,
    });
  },

  async saveAnswer(
    examId: number,
    payload: {
      writing_test?: any[];
      question_id: number;
      selected_choice_id: number;
    }
  ) {
    try {
      const res = await axiosInstance.post(
        `${API}save-answer/${examId}/`,
        payload
      );
      return res.data;
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data?.errors || {},
      };
    }
  },
  async generateExamLinkByCode(payload: { candidate_code: string }) {
    try {
      const res = await axiosInstance.post(
        `${API}generate_link_by_code/`,
        payload
      );
      return res.data;
    } catch (err: any) {
      return {
        success: false,
        error: err.response?.data?.error || "Something went wrong",
      };
    }
  },
  async generateExamLink(payload: { candidate_id: number }) {
    try {
      const res = await axiosInstance.post(`${API}generate_link/`, payload);
      return res.data;
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data?.errors || {},
      };
    }
  },
  async validateExamLink(token: string) {
    try {
      const res = await axiosInstance.get(
        `${API}validate_link/?token=${token}`
      );
      return res.data;
    } catch (err: any) {
      return {
        valid: false,
        error: err.response?.data?.error || "Something went wrong",
      };
    }
  },
};
